import ApiRequest from "../index"

const maisVendidosRequest = {
    get: async data => ApiRequest.get(`/v2/lojinha/products/top/list`),
    put: async data => ApiRequest.put(`/v2/lojinha/products/top/update`, {...data })
}   

export default maisVendidosRequest
